"use client";

import type { FeedResponse } from "@/actions/post";
import { PostList } from "@/components/posts";
import type { CommentsSheetViewer } from "@/components/posts/comments-sheet";

interface Props {
  hiiveId: number;
  viewer: CommentsSheetViewer;
  initialFeed?: FeedResponse;
}

export function HiivePostsTabClient({ hiiveId, viewer, initialFeed }: Props) {
  return (
    <PostList
      context={{ type: "hiive", hiiveId }}
      viewer={viewer}
      className="space-y-4"
      initialFeed={initialFeed}
    />
  );
}
